import { useState, useEffect } from 'react';
import { doc, onSnapshot, getDoc } from 'firebase/firestore';
import { db, auth } from '../../Services/firebase-config';

export const useHackathonCategories = () => {
    const [categories, setCategories] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const categoriesDocRef = doc(db, "hackathonCategories", "categories");

        // Set up real-time listener for categories
        const unsubscribe = onSnapshot(
            categoriesDocRef,
            (doc) => {
                try {
                    if (doc.exists()) {
                        const categoriesData = doc.data().categories || [];
                        setCategories(categoriesData);
                        setError(null);
                    } else {
                        console.log('No categories document found');
                        setCategories([]);
                    }
                } catch (err) {
                    console.error('Error processing categories data:', err);
                    setError(err.message);
                } finally {
                    setIsLoading(false);
                }
            },
            (err) => {
                console.error('Error listening to categories changes:', err);
                setError(err.message);
                setIsLoading(false);
            }
        );

        return () => unsubscribe();
    }, []);

    // Fallback function to fetch categories once (for compatibility)
    const fetchCategoriesOnce = async () => {
        try {
            setIsLoading(true);
            const categoriesDocRef = doc(db, "hackathonCategories", "categories");
            const categoriesDoc = await getDoc(categoriesDocRef);

            if (categoriesDoc.exists()) {
                const categoriesData = categoriesDoc.data().categories || [];
                setCategories(categoriesData);
            } else {
                setCategories([]);
            }
            setError(null);
        } catch (error) {
            console.error('Error fetching categories:', error);
            setError(error.message);
            setCategories([]);
        } finally {
            setIsLoading(false);
        }
    };

    return {
        categories,
        isLoading,
        error,
        fetchCategoriesOnce, // Fallback method
    };
};